import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Mic, Loader2 } from "lucide-react";
import { useStartSelfServeAssessment } from "@/lib/api";

interface StartSelfServeButtonProps {
  className?: string;
}

// Lets a self-registered learner (no teacher-assigned task) start the Physical
// Strand speaking assessment themselves and go straight to the recorder.
export default function StartSelfServeButton({ className }: StartSelfServeButtonProps) {
  const navigate = useNavigate();
  const start = useStartSelfServeAssessment();
  const [error, setError] = useState("");

  const handleStart = async () => {
    setError("");
    try {
      const assessment = await start.mutateAsync();
      navigate(`/student/task/${assessment.id}`);
    } catch {
      setError("Could not start the assessment. Please try again.");
    }
  };

  return (
    <div className={className}>
      <Button onClick={handleStart} disabled={start.isPending}>
        {start.isPending ? (
          <>
            <Loader2 className="w-4 h-4 mr-2 animate-spin" />
            Starting...
          </>
        ) : (
          <>
            <Mic className="w-4 h-4 mr-2" />
            Start the speaking assessment
          </>
        )}
      </Button>
      {error && <p className="text-sm text-red-500 mt-2">{error}</p>}
    </div>
  );
}
